import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { mustNumberPattern, numberMoreThanZeroPattern, userNamePattern } from 'src/app/app-const';

@Component({
  selector: 'app-nz-control-error-temp',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './nz-control-error-temp.component.html',
  styleUrls: ['./nz-control-error-temp.component.scss']
})
export class NzControlErrorTempComponent {
  @Input({ required: true }) control: FormControl | undefined;
  mustNumberPattern = mustNumberPattern;
  numberMoreThanZeroPattern = numberMoreThanZeroPattern;
  userNamePattern = userNamePattern;

  constructor(private readonly translate: TranslateService) {}

  get serverErrorMessage(): string {
    const serverError = this.control?.errors?.['server'];

    if (typeof serverError === 'string' && serverError.trim() !== '') {
      return serverError;
    }

    if (serverError && typeof serverError.message === 'string' && serverError.message.trim() !== '') {
      return serverError.message;
    }

    return this.translate.instant('SHARED.VALIDATION.INVALID_INPUT');
  }

  get outsideAcademyTimeMessage(): string {
    const outsideAcademyTime = this.control?.errors?.['outsideAcademyTime'];

    if (!outsideAcademyTime) {
      return this.translate.instant('SHARED.VALIDATION.OUTSIDE_ACADEMY_TIME');
    }

    if (typeof outsideAcademyTime === 'object') {
      const start = String((outsideAcademyTime as { start?: unknown }).start ?? '').trim();
      const end = String((outsideAcademyTime as { end?: unknown }).end ?? '').trim();

      if (start && end) {
        return this.translate.instant('SHARED.VALIDATION.OUTSIDE_ACADEMY_TIME_RANGE', { start, end });
      }
    }

    return this.translate.instant('SHARED.VALIDATION.OUTSIDE_ACADEMY_TIME');
  }
}
